<template>
  <div class="flex flex-col gap-y-2">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { provide, toRef } from 'vue';
import { useAccordionState, type AccordionMode } from './hooks.js';
import { accordionKey } from './injects.js';

interface Props {
  mode?: AccordionMode;
}

const props = withDefaults(defineProps<Props>(), { mode: 'single' });
const accordionState = useAccordionState(toRef(props, 'mode'));

provide(accordionKey, accordionState);
</script>

<style lang="scss" scoped></style>
